
























































import Vue from "vue";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default Vue.extend({

  name: 'AuthSignUp',
  props: ['signUpConfig'],
  data() {
    return {
      error: '',
      password: '',
      rePassword: '',
      username: '',
      showPassword: false,
      showRePassword: false,
      emailRules: [
        (v: any) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: {
        required: (value: any) => !!value || 'Required.',
        min: (v: string | any[]) => v.length >= 6 || 'Min 6 characters'
      },
      busy: false
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () => (this.password === this.rePassword) || 'Password must match'
    },
    options(): any {
      const defaults = {
        username: '',
      };
      return Object.assign(defaults, this.signUpConfig || {});
    },
  },
  mounted() {
  },
  methods: {
    signUp: function () {
      if (!this.validate()) {
        return null;
      }
      this.busy = true;
      let user: any = {
        username: this.username.toLowerCase(),
        password: this.password,
        attributes: {},
        // Pass client meta data as it is used by the backend to customize the message.
        clientMetadata: {
          "requestFromAddress": window.location.href.split('?')[0]
        }
      };
      Auth.signUp(user)
        .then((data: any) => {
          AmplifyEventBus.$emit('localUser', data.user);
          this.busy = false;
          if (data.userConfirmed === false) {
            return AmplifyEventBus.$emit('authState', 'confirmSignUp');
          }
          return AmplifyEventBus.$emit('authState', 'signIn')
        })
        .catch((e: any) => {
          this.setError(e);
          this.busy = false;
        });

    },
    signIn: function () {
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    validate() {
      return (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },
    emailChanged(data: string) {
      this.options.username = data;
    },
    setError: function (e: any) {
      this.error = e.message || e;
    },
  }
});
